import styled from 'styled-components';
export const BKJAlertWrapper = styled.div `
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 16px;
  width: 496px;
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.Grey1};
`;
export const IconWrapper = styled.div ``;
export const AlertText = styled.p `
  ${({ theme }) => theme.typography.Caption};
  color: ${({ status, theme }) => status === 'conflict' ? theme.colors.ErrorDefault : theme.colors.TextDarkGrey};
  margin: 0px 12px;
`;
export const DismissButton = styled.button `
  margin-top: auto;
  margin-bottom: auto;
  border: none;
  background: none;
  ${({ theme }) => theme.typography.TextLink};
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.PrimaryHover};
  }
  &:active {
    color: ${({ theme }) => theme.colors.PrimaryClick};
  }
`;
//# sourceMappingURL=BKJAlert.styled.js.map